import type { User } from '../../../../core/interfaces/backend/usuarios/usuarios.administration.interface';
import type { Role } from '../../../../core/interfaces/backend/roles/roles.administration.interface';
import type { Assignment } from '../../../../core/interfaces/backend/reasignaciones_usuarios/reasignaciones_usuarios.administration.interface';
import { Component, inject, Input, Output, EventEmitter, OnChanges, computed, signal, effect } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AdministracionService } from '../../../../services/backend/administracion/administracion.service';
import { AdminDataTableComponent, GridRow } from '../../../../shared/admin-data-table/admin-data-table.component';
import { GovcoConfirmModalComponent } from '../../../../shared/govco/govco-confirm-modal/govco-confirm-modal.component';
import { RolFormularioComponent } from '../rol-formulario/rol-formulario.component';
import { AsignarUsuariosRolComponent } from '../asignar-usuarios-rol/asignar-usuarios-rol.component';
@Component({selector:'sr-admin-roles',standalone:true,imports:[AdminDataTableComponent, RolFormularioComponent, AsignarUsuariosRolComponent],templateUrl:'./roles.component.html',styleUrl:'./roles.component.css'})
export class RolesComponent {
  readonly api=inject(AdministracionService);
  private readonly router=inject(Router);
  editing:Role|null=null; showForm=false; assigning:Role|null=null;
  readonly columns=[{key:'name',label:'Rol'},{key:'activeLabel',label:'Activo'},{key:'userCount',label:'Usuarios asignados'}];
  readonly actions=[{key:'edit',label:'Editar rol'},{key:'users',label:'Asignar usuarios'},{key:'permissions',label:'Permisos'}];
  readonly rows=computed(()=> (this.api.data()?.roles ?? []).map(r=>({...r,activeLabel:r.active?'Sí':'No'})));
  open(event:{key:string;row:GridRow}):void {
    const role=this.api.data()?.roles.find(r=>r.id===event.row.id); if(!role)return;
    if(event.key==='permissions'){void this.router.navigate(['/administracion/permisos'],{queryParams:{rol:role.id}});return;}
    this.showForm=event.key==='edit';this.editing=role;this.assigning=event.key==='users'?role:null;
  }
  create():void{this.editing=null;this.assigning=null;this.showForm=true;}

}
